import { DownOutlined } from "@ant-design/icons"
import { Dropdown, Menu, Space, Typography } from "antd"
import React, { FC } from "react"
import { truncate } from "../../../../../utils"
import "./index.less"

const Filter: FC<ActivityLogFilterInterface> = ({ filters, setFilters, specificFilters }) => {
  const actionOptions = ["All", "Created", "Edited", "Deleted", "Blocked", "Unblocked"].map((item, i) => ({
    key: String(i),
    value: item,
    label: item,
  }))
  const typeOptions = ["All", "Post", "Event", "Notification", "Link", "Assets", "Product", "User"].map((item, i) => ({
    key: String(i),
    value: item,
    label: item,
  }))

  const resetFilter = (type: string) => {
    switch (type) {
      case "name":
        setFilters({ ...filters, selectedName: "All" })
        break
      case "action-for":
        setFilters({ ...filters, selectedActionFor: "All" })
        break
    }
  }

  const activeSpecificFiltersAmount = specificFilters.length

  return (
    <div className={"filters-wrapper activity-log-filter"}>
      <div className={"filters"}>
        <Dropdown
          className={`action-filter ${filters.selectedAction != "All" && "active"}`}
          trigger={["click"]}
          overlay={
            <Menu
              onClick={e =>
                setFilters({
                  ...filters,
                  selectedAction: actionOptions.find(item => item.key == e.key)!.label,
                })
              }
              selectedKeys={[`${actionOptions.find(item => item.value == filters.selectedAction)?.key ?? "0"}`]}
            >
              {actionOptions.map(item => (
                <Menu.Item key={item.key}>{item.label}</Menu.Item>
              ))}
            </Menu>
          }
        >
          <Typography.Link>
            <Space className={"dropdown"}>
              {actionOptions.find(item => item.value == filters.selectedAction)?.label ?? "All"}
              <DownOutlined style={{ color: "black" }} />
            </Space>
          </Typography.Link>
        </Dropdown>

        <Dropdown
          className={`type-filter ${filters.selectedType != "All" && "active"}`}
          trigger={["click"]}
          overlay={
            <Menu
              onClick={e =>
                setFilters({
                  ...filters,
                  selectedType: typeOptions.find(item => item.key == e.key)!.label,
                })
              }
              selectedKeys={[`${typeOptions.find(item => item.value == filters.selectedType)?.key ?? "0"}`]}
            >
              {typeOptions.map(item => (
                <Menu.Item key={item.key}>{item.label}</Menu.Item>
              ))}
            </Menu>
          }
        >
          <Typography.Link>
            <Space className={"dropdown"}>
              {typeOptions.find(item => item.value == filters.selectedType)?.label ?? "All"}
              <DownOutlined style={{ color: "black" }} />
            </Space>
          </Typography.Link>
        </Dropdown>
      </div>

      <div className={"specific-filters-wrapper"}>
        Filters ({activeSpecificFiltersAmount})
        <div className={"specific-filters-list"}>
          {specificFilters &&
            specificFilters.map((filter: any, i: number) => (
              <div
                className={"block"}
                key={`filter-${i}`}
                style={{ backgroundColor: filter.backgroundColor, color: filter.color }}
              >
                {truncate(filter.option, 32)}
                <div className={"remove-filter"} onClick={() => resetFilter(filter.type)}>
                  <div className={"l-line"} />
                  <div className={"r-line"} />
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  )
}

export default Filter
